module.exports = __webpack_public_path__ + "static/media/p.87963420.png";